define( [
	"../Data"
], function( Data ) {
	return new Data();
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/data/var/dataUser.js
 ** module id = 844
 ** module chunks = 2
 **/